import { TooltipPosition, TrainerData } from "../IronmonMapUtils";

export const defaultTrainerHeight = 24;
export const defaultTrainerWidth = 18;

export const trainers: TrainerData[] = [
  // Cherrygrove
  {
    name: "Rival",
    numPokemon: 1,
    pokemonLevels: [8],
    x: 8057,
    y: 4833,
  },

  // Rt 30
  {
    name: "Youngster Joey",
    numPokemon: 1,
    pokemonLevels: [6],
    x: 7692,
    y: 4015,
  },
  {
    name: "Youngster Mikey",
    numPokemon: 2,
    pokemonLevels: [3, 6],
    x: 7674,
    y: 3929,
  },
  {
    name: "Bug Catcher Don",
    numPokemon: 2,
    pokemonLevels: [5, 5],
    x: 7643,
    y: 3586,
  },

  // Rt 31
  {
    name: "Bug Catcher Wade",
    numPokemon: 4,
    pokemonLevels: [3, 3, 3, 5],
    x: 7482,
    y: 3351,
  },

  // Sprout Tower
  // 1F
  {
    name: "Sage Chow",
    numPokemon: 3,
    pokemonLevels: [5, 5, 5],
    x: 5861,
    y: 2281,
  },

  // 2F
  {
    name: "Sage Nico",
    numPokemon: 3,
    pokemonLevels: [5, 5, 5],
    x: 6469,
    y: 2317,
  },
  {
    name: "Sage Edmond",
    numPokemon: 3,
    pokemonLevels: [5, 5, 5],
    x: 6362,
    y: 2490,
  },

  // 3F
  {
    name: "Sage Jin",
    numPokemon: 1,
    pokemonLevels: [9],
    x: 6949,
    y: 2465,
  },
  {
    name: "Sage Neal",
    numPokemon: 1,
    pokemonLevels: [9],
    x: 6868,
    y: 2427,
  },
  {
    name: "Sage Troy",
    numPokemon: 2,
    pokemonLevels: [11, 11],
    x: 6932,
    y: 2389,
  },
  {
    name: "Elder Li",
    numPokemon: 3,
    pokemonLevels: [11, 11, 15],
    x: 6851,
    y: 2267,
  },

  // Rt 32
  {
    name: "Youngster Albert",
    numPokemon: 2,
    pokemonLevels: [9, 12],
    x: 6371,
    y: 4007,
  },
  {
    name: "Picknicker Liz",
    numPokemon: 1,
    pokemonLevels: [12],
    x: 6308,
    y: 4168,
  },
  {
    name: "Camper Roland",
    numPokemon: 1,
    pokemonLevels: [14],
    x: 6083,
    y: 4699,
  },
  {
    name: "Fisherman Henry",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 6229,
    y: 4584,
  },
  {
    name: "Fisherman Justin",
    numPokemon: 4,
    pokemonLevels: [8, 8, 23, 8],
    x: 6260,
    y: 4609,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Fisherman Ralph",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 6339,
    y: 4742,
  },
  {
    name: "Youngster Gordon",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 6208,
    y: 4939,
    spinner: true,
  },
  {
    name: "Bird Keeper Peter",
    numPokemon: 3,
    pokemonLevels: [9, 9, 12],
    x: 6336,
    y: 5310,
  },

  // Union Cave
  {
    name: "Firebreather Ray",
    numPokemon: 1,
    pokemonLevels: [14],
    x: 6663,
    y: 3614,
  },
  {
    name: "Hiker Daniel",
    numPokemon: 1,
    pokemonLevels: [17],
    x: 6615,
    y: 3879,
  },
  {
    name: "Hiker Russel",
    numPokemon: 3,
    pokemonLevels: [6, 9, 12],
    x: 6855,
    y: 3916,
  },
  {
    name: "Firebreather Bill",
    numPokemon: 2,
    pokemonLevels: [9, 9],
    x: 6904,
    y: 4141,
  },
  {
    name: "Poké Maniac Larry",
    numPokemon: 1,
    pokemonLevels: [17],
    x: 6727,
    y: 4274,
  },

  // Rt 33
  {
    name: "Hiker Anthony",
    numPokemon: 2,
    pokemonLevels: [17, 17],
    x: 6174,
    y: 5666,
    spinner: true,
  },

  // Slowpoke Well
  {
    name: "Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [14, 14],
    x: 6989,
    y: 5615,
  },
  {
    name: "Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [14, 17],
    x: 6906,
    y: 5553,
  },
  {
    name: "Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [11, 14, 14],
    x: 6751,
    y: 5590,
  },
  {
    name: "Executive Proton",
    numPokemon: 2,
    pokemonLevels: [12, 18],
    x: 6750,
    y: 5516,
  },

  // Azalea
  {
    name: "Rival",
    numPokemon: 3,
    pokemonLevels: [21, 24, 27],
    x: 5224,
    y: 5617,
  },

  // Rt 34
  {
    name: "Youngster Samuel",
    numPokemon: 4,
    pokemonLevels: [11, 15, 12, 12],
    x: 4902,
    y: 5372,
  },
  {
    name: "Pokéfan Brandon",
    numPokemon: 2,
    pokemonLevels: [20, 20],
    x: 4998,
    y: 5224,
  },
  {
    name: "Picnicker Gina",
    numPokemon: 3,
    pokemonLevels: [14, 14, 18],
    x: 4757,
    y: 5200,
  },
  {
    name: "Youngster Ian",
    numPokemon: 2,
    pokemonLevels: [15, 18],
    x: 4917,
    y: 5064,
  },
  {
    name: "Policeman Keith",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 4726,
    y: 4892,
  },
  {
    name: "Camper Todd",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 4742,
    y: 4781,
  },
  {
    name: "Ace Trainer Irene",
    numPokemon: 2,
    pokemonLevels: [33, 36],
    x: 4743,
    y: 5729,
  },
  {
    name: "Ace Trainer Jenn",
    numPokemon: 2,
    pokemonLevels: [36, 39],
    x: 4904,
    y: 5729,
  },
  {
    name: "Ace Trainer Kate",
    numPokemon: 2,
    pokemonLevels: [39, 42],
    x: 4824,
    y: 5778,
  },

  // Goldenrod Tunnel
  {
    name: "PokéManiac Donald",
    numPokemon: 2,
    pokemonLevels: [17, 17],
    x: 5180,
    y: 4089,
  },
  {
    name: "Super Nerd Teru",
    numPokemon: 4,
    pokemonLevels: [11, 17, 11, 14],
    x: 5084,
    y: 4043,
  },
  {
    name: "PokéManiac Issac",
    numPokemon: 1,
    pokemonLevels: [18],
    x: 5197,
    y: 3784,
  },
  {
    name: "Super Nerd Eric",
    numPokemon: 2,
    pokemonLevels: [17, 17],
    x: 5084,
    y: 3756,
  },

  // Rt 35
  {
    name: "Picknicker Kim",
    numPokemon: 1,
    pokemonLevels: [23],
    x: 4598,
    y: 3697,
  },
  {
    name: "Camper Elliot",
    numPokemon: 2,
    pokemonLevels: [20, 23],
    x: 4790,
    y: 3450,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Picknicker Brooke",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 4773,
    y: 3450,
  },
  {
    name: "Camper Ivan",
    numPokemon: 3,
    pokemonLevels: [15, 21, 15],
    x: 4677,
    y: 3438,
  },
  {
    name: "Juggler Irwin",
    numPokemon: 4,
    pokemonLevels: [15, 9, 3, 21],
    x: 4728,
    y: 3349,
  },
  {
    name: "Firebreather Walt",
    numPokemon: 2,
    pokemonLevels: [17, 24],
    x: 4679,
    y: 3302,
  },
  {
    name: "Policeman Dirk",
    numPokemon: 2,
    pokemonLevels: [21, 21],
    x: 4742,
    y: 3204,
  },
  {
    name: "Bug Catcher Arnie",
    numPokemon: 1,
    pokemonLevels: [23],
    x: 4949,
    y: 3192,
  },
  {
    name: "Bird Keeper Bryan",
    numPokemon: 2,
    pokemonLevels: [18, 21],
    x: 4773,
    y: 3770,
  },

  // Rt 36
  {
    name: "Psychic Mark",
    numPokemon: 3,
    pokemonLevels: [21, 21, 24],
    x: 4981,
    y: 2912,
  },
  {
    name: "School Kid Alan",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 5317,
    y: 2950,
  },

  // National Park
  // South
  {
    name: "Pokéfan Beverly",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 3586,
    y: 4352,
    spinner: true,
  },
  {
    name: "School Kid Jack",
    numPokemon: 2,
    pokemonLevels: [18, 23],
    x: 3794,
    y: 4245,
    spinner: true,
  },
  // North
  {
    name: "Pokéfan William",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 3540,
    y: 3971,
    spinner: true,
  },
  {
    name: "Lass Krise",
    numPokemon: 2,
    pokemonLevels: [21, 26],
    x: 3330,
    y: 4056,
    spinner: true,
  },

  // Rt 37
  {
    name: "Twins Tori & Til",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 5150,
    y: 2487,
  },
  {
    name: "Beauty Callie",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 5078,
    y: 2396,
  },
  {
    name: "Beauty Kassandra",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 5222,
    y: 2396,
  },
  {
    name: "Psychic Greg",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 5334,
    y: 2471,
    spinner: true,
  },

  // Rt 38
  {
    name: "Sailor Harry",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 4275,
    y: 1927,
    spinner: true,
  },
  {
    name: "Lass Dana",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 4034,
    y: 1879,
    spinner: true,
  },
  {
    name: "School Kid Chad",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 3684,
    y: 1869,
  },
  {
    name: "Beauty Valerie",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3859,
    y: 1955,
  },
  {
    name: "Bird Keeper Toby",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 4021,
    y: 2016,
  },

  // Rt 39
  {
    name: "Psychic Nelson",
    numPokemon: 2,
    pokemonLevels: [26, 30],
    x: 3332,
    y: 2084,
    walker: true,
  },
  {
    name: "Sailor Eugene",
    numPokemon: 3,
    pokemonLevels: [26, 26, 29],
    x: 3270,
    y: 2356,
    spinner: true,
  },
  {
    name: "Pokéfan Derek",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 3308,
    y: 2394,
    walker: true,
  },
  {
    name: "Pokéfan Ruth",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3324,
    y: 2432,
    walker: true,
  },

  // Olivine City
  // {
  //   name: "Beauty Charlotte",
  //   numPokemon: 1,
  //   pokemonLevels: [24],
  //   // TODO:
  //   x: 0,
  //   y: 0,
  // },

  // Burned Tower
  {
    name: "Rival",
    numPokemon: 4,
    pokemonLevels: [30, 30, 27, 33],
    x: 4778,
    y: 2129,
  },
  {
    name: "Firebreather Ned",
    numPokemon: 3,
    pokemonLevels: [24, 26, 24],
    x: 4760,
    y: 2054,
  },
  {
    name: "Firebreather Richard",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 4506,
    y: 2067,
  },

  // Lighthouse
  // 2F
  {
    name: "Gentleman Alfred",
    numPokemon: 1,
    pokemonLevels: [33],
    x: 2728,
    y: 2928,
  },
  {
    name: "Sailor Huey",
    numPokemon: 2,
    pokemonLevels: [27, 30],
    x: 2951,
    y: 2989,
  },

  // 3F
  {
    name: "Bird Keeper Theo",
    numPokemon: 5,
    pokemonLevels: [26, 23, 29, 23, 23],
    x: 2899,
    y: 2645,
    spinner: true,
  },
  {
    name: "Sailor Kent",
    numPokemon: 2,
    pokemonLevels: [27, 30],
    x: 2885,
    y: 2757,
  },
  {
    name: "Bird Keeper Denis",
    numPokemon: 3,
    pokemonLevels: [27, 30, 27],
    x: 2723,
    y: 2696,
    spinner: true,
  },

  // 4F
  {
    name: "Gentleman Preston",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 2930,
    y: 2435,
  },
  {
    name: "Lass Connie",
    numPokemon: 1,
    pokemonLevels: [32],
    x: 2850,
    y: 2525,
  },

  // 5F
  {
    name: "Sailor Terrell",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 2804,
    y: 2237,
  },
  {
    name: "Sailor Roberto",
    numPokemon: 3,
    pokemonLevels: [27, 27, 27],
    x: 2915,
    y: 2213,
    spinner: true,
  },

  // Rt 40
  {
    name: "Swimmer Simon",
    numPokemon: 2,
    pokemonLevels: [30, 30],
    x: 2760,
    y: 3403,
  },
  {
    name: "Swimmer Elaine",
    numPokemon: 1,
    pokemonLevels: [32],
    x: 2855,
    y: 3515,
  },
  {
    name: "Swimmer Randall",
    numPokemon: 3,
    pokemonLevels: [27, 30, 27],
    x: 2724,
    y: 3674,
  },
  {
    name: "Swimmer Paula",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 2799,
    y: 3725,
  },

  // Rt 41
  {
    name: "Swimmer George",
    numPokemon: 6,
    pokemonLevels: [24, 24, 26, 26, 29, 29],
    x: 2440,
    y: 3978,
  },
  {
    name: "Swimmer Susie",
    numPokemon: 2,
    pokemonLevels: [30, 33],
    x: 2211,
    y: 3952,
  },
  {
    name: "Swimmer Charlie",
    numPokemon: 3,
    pokemonLevels: [32, 29, 29],
    x: 2881,
    y: 4051,
  },
  {
    name: "Swimmer Kaylee",
    numPokemon: 3,
    pokemonLevels: [27, 30, 30],
    x: 2898,
    y: 4297,
  },
  {
    name: "Swimmer Matthew",
    numPokemon: 1,
    pokemonLevels: [35],
    x: 2754,
    y: 4260,
  },
  {
    name: "Swimmer Berke",
    numPokemon: 1,
    pokemonLevels: [35],
    x: 2450,
    y: 4260,
  },
  {
    name: "Swimmer Kara",
    numPokemon: 2,
    pokemonLevels: [30, 30],
    x: 2516,
    y: 4385,
  },
  {
    name: "Swimmer Wendy",
    numPokemon: 2,
    pokemonLevels: [32, 32],
    x: 2422,
    y: 4139,
  },
  {
    name: "Swimmer Ronald",
    numPokemon: 2,
    pokemonLevels: [30, 30],
    x: 2453,
    y: 4581,
  },
  {
    name: "Swimmer Denise",
    numPokemon: 1,
    pokemonLevels: [33],
    x: 2226,
    y: 4581,
  },

  // Cianwood
  {
    name: "Eusine",
    numPokemon: 3,
    pokemonLevels: [38, 41, 38],
    // TODO
    x: 1664,
    y: 4096,
  },

  // Rt 47
  {
    name: "Hiker Denis",
    numPokemon: 3,
    pokemonLevels: [29, 29, 29],
    x: 1038,
    y: 4352,
    spinner: true,
  },
  {
    name: "Camper Grant",
    numPokemon: 2,
    pokemonLevels: [32, 32],
    x: 753,
    y: 4336,
  },
  {
    name: "Double Team Thom & Kae",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 975,
    y: 4212,
  },
  {
    name: "Young Couple Duff & Eda",
    numPokemon: 2,
    pokemonLevels: [33, 33],
    x: 488,
    y: 3984,
  },

  // Rt 42
  {
    name: "Fisherman Tully",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 6629,
    y: 2040,
  },
  {
    name: "Poké Maniac Shane",
    numPokemon: 2,
    pokemonLevels: [26, 26],
    x: 6823,
    y: 1992,
  },
  {
    name: "Hiker Benjamin",
    numPokemon: 3,
    pokemonLevels: [23, 23, 26],
    x: 6917,
    y: 2054,
  },

  // Rt 43
  {
    name: "Camper Spencer",
    numPokemon: 3,
    pokemonLevels: [27, 27, 30],
    x: 7320,
    y: 1711,
  },
  {
    name: "Picnicker Tiffany",
    numPokemon: 1,
    pokemonLevels: [32],
    x: 7318,
    y: 1440,
  },
  {
    name: "Poké Maniac Brent",
    numPokemon: 2,
    pokemonLevels: [30, 36],
    x: 7399,
    y: 1376,
  },
  {
    name: "Poké Maniac Beckett",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 7495,
    y: 1243,
  },
  {
    name: "Poké Maniac Ron",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 7383,
    y: 1156,
  },
  {
    name: "Fisherman Marvin",
    numPokemon: 3,
    pokemonLevels: [15, 30, 23],
    x: 7222,
    y: 1266,
  },

  // Lake of Rage
  {
    name: "Fisherman Andre",
    numPokemon: 1,
    pokemonLevels: [41],
    x: 7458,
    y: 858,
  },
  {
    name: "Fisherman Raymond",
    numPokemon: 4,
    pokemonLevels: [33, 33, 33, 33],
    x: 7592,
    y: 801,
  },
  {
    name: "Ace Trainer Lois",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 7705,
    y: 551,
  },
  // TODO: where this dude
  // {
  //   name: "Ace Trainer Alton",
  //   numPokemon: 3,
  //   pokemonLevels: [36, 36, 36],
  //   x: 0,
  //   y: 0,
  // },

  // Team Rocket HQ

  // B1F

  // Statue 1
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [26, 29],
    x: 8170,
    y: 1086,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 8170,
    y: 1108,
    tooltipPosition: TooltipPosition.Left,
  },

  // Statue 2
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [26, 29],
    x: 7754,
    y: 1082,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 7754,
    y: 1108,
    tooltipPosition: TooltipPosition.Bottom,
  },

  // Statue 3
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [26, 29],
    x: 8170,
    y: 1168,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 8170,
    y: 1191,
    tooltipPosition: TooltipPosition.Bottom,
  },

  // Statue 4
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [26, 29],
    x: 8170,
    y: 1390,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 8170,
    y: 1414,
    tooltipPosition: TooltipPosition.Bottom,
  },

  // Statue 5
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [26, 29],
    x: 7753,
    y: 1390,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [24, 26, 27],
    x: 7753,
    y: 1414,
    tooltipPosition: TooltipPosition.Bottom,
  },

  {
    name: "Scientist Gregg",
    numPokemon: 3,
    pokemonLevels: [30, 30, 30],
    x: 8044,
    y: 1312,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 4,
    pokemonLevels: [24, 24, 24, 24],
    x: 7661,
    y: 1103,
  },

  // B2F
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 8076,
    y: 1765,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 8235,
    y: 1759,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [26, 26, 26],
    x: 7675,
    y: 1486,
  },
  {
    name: "Team Rocket Grunt & Executive Ariana",
    numPokemon: 5,
    pokemonLevels: [38, 38, 41, 27, 30],
    x: 7954,
    y: 1734,
  },

  // B3F
  {
    name: "Scientist Ross",
    numPokemon: 2,
    pokemonLevels: [33, 33],
    x: 8907,
    y: 1672,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 8844,
    y: 1634,
  },
  {
    name: "Scientist Mitch",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 8587,
    y: 1795,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 8475,
    y: 1760,
  },
  {
    name: "Executive Petrel",
    numPokemon: 3,
    pokemonLevels: [33, 33, 36],
    x: 8572,
    y: 1536,
  },

  // Radio Tower

  // 1F
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [36, 36],
    x: 4480,
    y: 3366,
  },

  // 2F
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [39],
    x: 4334,
    y: 3273,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 5,
    pokemonLevels: [32, 32, 35, 35, 35],
    x: 4319,
    y: 3188,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [39, 39],
    x: 4225,
    y: 3252,
    spinner: true,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [35, 35, 38],
    x: 4158,
    y: 3301,
  },

  // 3F
  {
    name: "Team Rocket Grunt",
    numPokemon: 4,
    pokemonLevels: [35, 35, 35, 35],
    x: 4254,
    y: 3011,
  },
  {
    name: "Scientist Garett",
    numPokemon: 3,
    pokemonLevels: [41, 41, 41],
    x: 4321,
    y: 3124,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [39],
    x: 4384,
    y: 3097,
  },
  // After Basement
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [36, 39],
    x: 4444,
    y: 3034,
  },

  // 4F
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [33, 36, 33],
    x: 4243,
    y: 2832,
  },
  {
    name: "Scientist Trenton",
    numPokemon: 1,
    pokemonLevels: [45],
    x: 4171,
    y: 2887,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 4,
    pokemonLevels: [32, 32, 35, 36],
    x: 4496,
    y: 2910,
    tooltipPosition: TooltipPosition.Bottom,
  },
  // After Basement
  {
    name: "Executive Proton",
    numPokemon: 2,
    pokemonLevels: [42, 50],
    x: 4477,
    y: 2868,
  },

  // 5F
  {
    name: "Executive Petrel",
    numPokemon: 6,
    pokemonLevels: [45, 45, 45, 45, 48, 45],
    x: 4229,
    y: 2757,
  },
  // After Basement
  {
    name: "Executive Ariana",
    numPokemon: 3,
    pokemonLevels: [48, 48, 48],
    x: 4325,
    y: 2640,
  },

  // Observation Deck
  {
    name: "Executive Archer",
    numPokemon: 6,
    pokemonLevels: [53, 53, 57, 53, 53, 53],
    x: 4330,
    y: 2389,
  },

  // Rocket Goldenrod Basement
  // Exterior
  {
    name: "Rival",
    numPokemon: 5,
    pokemonLevels: [48, 45, 45, 51, 51],
    x: 3863,
    y: 3602,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [41],
    x: 3864,
    y: 3656,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 3,
    pokemonLevels: [35, 35, 38],
    x: 3830,
    y: 3589,
  },
  {
    name: "Burglar Duncan",
    numPokemon: 3,
    pokemonLevels: [35, 35, 38],
    x: 3671,
    y: 3726,
  },
  {
    name: "Burglar Orson",
    numPokemon: 2,
    pokemonLevels: [39, 36],
    x: 3638,
    y: 3649,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [36, 36],
    x: 3607,
    y: 3591,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 3942,
    y: 3728,
  },

  // Interior
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [36, 36],
    x: 4298,
    y: 3740,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 4486,
    y: 3645,
    walker: true,
  },
  {
    name: "Team Rocket Grunt",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 4310,
    y: 3557,
  },

  // Rt 44
  {
    name: "Psychic Phil",
    numPokemon: 2,
    pokemonLevels: [41, 44],
    x: 7833,
    y: 2053,
  },
  {
    name: "Fisherman Edgar",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 8121,
    y: 2137,
  },
  {
    name: "Ace Trainer Cybil",
    numPokemon: 2,
    pokemonLevels: [44, 44],
    x: 8378,
    y: 2154,
  },
  {
    name: "Ace Trainer Allen",
    numPokemon: 2,
    pokemonLevels: [44, 44],
    x: 8569,
    y: 2151,
  },
  {
    name: "Poké Maniac Zach",
    numPokemon: 1,
    pokemonLevels: [45],
    x: 8554,
    y: 1879,
  },
  {
    name: "Fisherman Wilton",
    numPokemon: 3,
    pokemonLevels: [39, 39, 42],
    x: 8424,
    y: 1891,
  },
  {
    name: "Bird Keeper Vance",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 8970,
    y: 1971,
  },

  // Rt 45
  {
    name: "Hiker Erik",
    numPokemon: 3,
    pokemonLevels: [36, 41, 41],
    x: 9337,
    y: 2582,
  },
  {
    name: "Ace Trainer Ryan",
    numPokemon: 2,
    pokemonLevels: [38, 41],
    x: 9483,
    y: 2619,
  },
  {
    name: "Ace Trainer Kelly",
    numPokemon: 3,
    pokemonLevels: [41, 36, 36],
    x: 9355,
    y: 2989,
  },
  {
    name: "Hiker Parry",
    numPokemon: 1,
    pokemonLevels: [45],
    x: 9193,
    y: 2852,
  },
  {
    name: "Black Belt Kenji",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 9432,
    y: 3295,
  },
  {
    name: "Hiker Timothy",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 9354,
    y: 3572,
  },
  {
    name: "Hiker Michael",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 9481,
    y: 3586,
  },

  // Rt 46
  {
    name: "Camper Ted",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 8681,
    y: 4138,
    spinner: true,
  },
  {
    name: "Picknicker Erin",
    numPokemon: 2,
    pokemonLevels: [26, 21],
    x: 8681,
    y: 4187,
  },
  {
    name: "Hiker Bailey",
    numPokemon: 5,
    pokemonLevels: [20, 20, 20, 20, 20],
    x: 8890,
    y: 4247,
  },

  // Dragon Den
  {
    name: "Ace Trainer Kobe",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 10262,
    y: 831,
  },
  {
    name: "Ace Trainer Piper",
    numPokemon: 3,
    pokemonLevels: [50, 50, 53],
    x: 9972,
    y: 964,
  },
  {
    name: "Twins Clea & Gil",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9875,
    y: 1099,
  },

  // Mt. Mortar
  {
    name: "Super Nerd Hugh",
    numPokemon: 1,
    pokemonLevels: [59],
    x: 5296,
    y: 1537,
  },
  {
    name: "Black Belt Kiyo",
    numPokemon: 2,
    pokemonLevels: [51, 51],
    x: 5148,
    y: 313,
  },
  {
    name: "Super Nerd Markus",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 6055,
    y: 596,
  },
  {
    name: "Poké Maniac Harrison",
    numPokemon: 2,
    pokemonLevels: [26, 26],
    x: 6214,
    y: 1004,
  },

  // Rt 27
  {
    name: "Ace Trainer Megan",
    numPokemon: 3,
    pokemonLevels: [48, 48, 48],
    x: 10954,
    y: 4791,
  },
  {
    name: "Ace Trainer Blake",
    numPokemon: 3,
    pokemonLevels: [50, 47, 47],
    x: 11289,
    y: 4803,
    spinner: true,
  },
  {
    name: "Bird Keeper Jose",
    numPokemon: 1,
    pokemonLevels: [60],
    x: 11467,
    y: 4937,
  },
  {
    name: "Ace Trainer Brian",
    numPokemon: 1,
    pokemonLevels: [53],
    x: 11794,
    y: 4826,
    walker: true,
  },
  {
    name: "Psychic Eli",
    numPokemon: 3,
    pokemonLevels: [45, 45, 51],
    x: 12506,
    y: 4839,
    spinner: true,
  },
  {
    name: "Ace Trainer Reena",
    numPokemon: 3,
    pokemonLevels: [54, 50, 54],
    x: 12826,
    y: 4876,
  },

  // Rt 26
  {
    name: "Fisherman Scott",
    numPokemon: 3,
    pokemonLevels: [45, 45, 51],
    x: 13472,
    y: 4851,
  },
  {
    name: "Psychic Vernon",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 13628,
    y: 4387,
  },
  {
    name: "Ace Trainer Joyce",
    numPokemon: 2,
    pokemonLevels: [54, 54],
    x: 13534,
    y: 3899,
    spinner: true,
  },
  {
    name: "Ace Trainer Gaven",
    numPokemon: 3,
    pokemonLevels: [48, 48, 48],
    x: 13680,
    y: 3677,
  },
  {
    name: "Ace Trainer Jake",
    numPokemon: 3,
    pokemonLevels: [50, 53, 50],
    x: 13600,
    y: 3533,
  },
  {
    name: "Ace Trainer Jamie",
    numPokemon: 2,
    pokemonLevels: [54, 47],
    x: 13470,
    y: 3177,
  },

  // Victory Road
  {
    name: "Rival",
    numPokemon: 6,
    pokemonLevels: [54, 57, 56, 56, 56, 60],
    x: 12764,
    y: 2920,
  },

  // Violet Gym
  {
    name: "Bird Keeper Abe",
    numPokemon: 1,
    pokemonLevels: [14],
    x: 7059,
    y: 2970,
  },
  {
    name: "Bird Keeper Rod",
    numPokemon: 2,
    pokemonLevels: [11, 11],
    x: 7157,
    y: 2922,
  },
  {
    name: "Falkner",
    numPokemon: 5,
    pokemonLevels: [14, 14, 14, 14, 20],
    x: 7107,
    y: 2834,
  },

  // Azalea Gym
  {
    name: "Bug Catcher Al",
    numPokemon: 2,
    pokemonLevels: [18, 18],
    x: 4462,
    y: 5657,
  },
  {
    name: "Bug Catcher Benny",
    numPokemon: 3,
    pokemonLevels: [11, 14, 18],
    x: 4334,
    y: 5631,
  },
  {
    name: "Bug Catcher Josh",
    numPokemon: 1,
    pokemonLevels: [20],
    x: 4461,
    y: 5472,
  },
  {
    name: "Twins Amy & Mimi",
    numPokemon: 2,
    pokemonLevels: [15, 15],
    x: 4261,
    y: 5475,
  },
  {
    name: "Bugsy",
    numPokemon: 6,
    pokemonLevels: [26, 23, 23, 23, 23, 23],
    x: 4366,
    y: 5447,
  },

  // Goldenrod Gym
  {
    name: "Beauty Victoria",
    numPokemon: 3,
    pokemonLevels: [14, 20, 24],
    x: 5128,
    y: 4255,
  },
  {
    name: "Beauty Samantha",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 5415,
    y: 4374,
  },
  {
    name: "Lass Carrie",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 5176,
    y: 4374,
  },
  {
    name: "Lass Cathy",
    numPokemon: 3,
    pokemonLevels: [23, 23, 23],
    x: 5255,
    y: 4337,
  },
  {
    name: "Whitney",
    numPokemon: 5,
    pokemonLevels: [26, 26, 26, 29, 26],
    x: 5239,
    y: 4201,
  },

  // Ecruteak Gym
  {
    name: "Medium Georgina",
    numPokemon: 5,
    pokemonLevels: [24, 24, 24, 24, 24],
    x: 5710,
    y: 2617,
  },
  {
    name: "Medium Grace",
    numPokemon: 2,
    pokemonLevels: [30, 30],
    x: 5740,
    y: 2508,
  },
  {
    name: "Medium Edith",
    numPokemon: 1,
    pokemonLevels: [33],
    x: 5583,
    y: 2496,
  },
  {
    name: "Medium Martha",
    numPokemon: 3,
    pokemonLevels: [27, 30, 30],
    x: 5614,
    y: 2371,
  },
  {
    name: "Morty",
    numPokemon: 6,
    pokemonLevels: [32, 38, 32, 32, 32, 35],
    x: 5597,
    y: 2235,
  },

  // Cianwood Gym
  {
    name: "Black Belt Yoshi",
    numPokemon: 1,
    pokemonLevels: [41],
    x: 1408,
    y: 4818,
    walker: true,
  },
  {
    name: "Black Belt Lao",
    numPokemon: 1,
    pokemonLevels: [41],
    x: 1624,
    y: 4784,
  },
  {
    name: "Black Belt Nob",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 1449,
    y: 4748,
  },
  {
    name: "Black Belt Lung",
    numPokemon: 3,
    pokemonLevels: [35, 38, 35],
    x: 1613,
    y: 4713,
    walker: true,
  },
  {
    name: "Chuck",
    numPokemon: 5,
    pokemonLevels: [44, 47, 44, 44, 44],
    x: 1545,
    y: 4845,
  },

  // Olivine Gym
  {
    name: "Jasmine",
    numPokemon: 6,
    pokemonLevels: [45, 45, 45, 45, 45, 53],
    x: 3600,
    y: 2436,
  },

  // Mahogany Gym
  {
    name: "Skier Diana",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 7319,
    y: 2635,
  },
  {
    name: "Boarder Patton",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 7462,
    y: 2635,
  },
  {
    name: "Boarder Deandre",
    numPokemon: 3,
    pokemonLevels: [38, 38, 39],
    x: 7337,
    y: 2407,
  },
  {
    name: "Skier Jill",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 7352,
    y: 2323,
  },
  {
    name: "Boarder Gerardo",
    numPokemon: 3,
    pokemonLevels: [38, 38, 39],
    x: 7449,
    y: 2358,
  },
  {
    name: "Pryce",
    numPokemon: 6,
    pokemonLevels: [45, 51, 45, 48, 45, 45],
    x: 7416,
    y: 2259,
  },

  // Blackthorn Gym
  {
    name: "Ace Trainer Paulo",
    numPokemon: 3,
    pokemonLevels: [53, 53, 53],
    x: 10230,
    y: 2288,
    spinner: true,
  },
  {
    name: "Ace Trainer Lola",
    numPokemon: 2,
    pokemonLevels: [53, 56],
    x: 10184,
    y: 2229,
  },
  {
    name: "Ace Trainer Cody",
    numPokemon: 2,
    pokemonLevels: [53, 56],
    x: 10374,
    y: 2140,
    spinner: true,
  },
  {
    name: "Ace Trainer Fran",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 10392,
    y: 2031,
    spinner: true,
  },
  {
    name: "Ace Trainer Mike",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 10262,
    y: 1969,
  },
  {
    name: "Clair",
    numPokemon: 6,
    pokemonLevels: [57, 57, 57, 57, 57, 62],
    x: 10247,
    y: 1513,
  },
];
